import { defaultStateSelector } from '@lingoda/core';
import { STORE_KEY } from '../constants';
import type { State } from '../reducers';

export const timeSelector = defaultStateSelector<State, typeof STORE_KEY>(STORE_KEY) as (
    state?: unknown,
) => Date;
